export const url = "https://sea-lion-app-z74d3.ondigitalocean.app/api/v1";